import { UserSlice } from './slice';

export const UserReducer = UserSlice.reducer;
